export default "__VITE_ASSET__Dz3Sjs0___"